module.exports = __webpack_public_path__ + "fonts/TitilliumWeb-Bold.08d3740.ttf";